/*
*   主入口
*/

import { Component } from 'react';
import {
    ConfigProvider,
    Layout,
    Flex,
    Row,
    Col,
    message,
    Image,
    Select,
    Button,
    Tooltip,
    Progress,
    InputNumber,
} from 'antd';
import { XProvider } from "@ant-design/x";
import $ from 'jquery';
import cookie from "react-cookies";
import './css/app.css';
import CNF from './incs/Config';
import { PlusOutlined, HistoryOutlined } from '@ant-design/icons';
import {
    locale,
    AddRequestHeaders,
    UjoinParams,
    DeleteCookies,
    winHeight,
    winWidth,
    CurrentTime,
    NumberToMillionFormat,
    isMobileDevice,
} from './incs/FunHelper';

import LogoLT from './pages/chats/LogoLT';
import XinYuanWebChatX from './pages/chats/XinYuanWebChatX';
import History from './pages/chats/History';
import XAvatar from './components/XAvatar';
import NetworkSource from './pages/chats/NetworkSource';

// 主题色全局变量
global.THEMECOLOR = CNF.cookies.keyThemeColor ? cookie.load(CNF.cookies.keyThemeColor) : CNF.themeColors[0];

const { Header, Sider, Content, Footer } = Layout;
const Option = Select.Option;

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            preGroup: 'xzt',
            navLists: [],
            btnLists: '',
            serInfos: [],
            qtaInfos: '',
            model: CNF.models[0],
            versionInfo: CNF.models[0].versions[0],
            newSessionTag: 1,
            isOpenHistory: false,       //  是否打开历史会话
            isOpenNetworkSource: false, //  是否打开网络来源
            networkSourceData: [],      //  网络来源数据
            dialogueUlid: '',           //  历史会话Ulid
            conversationId: '',         //  会话Id
            messages: [],               //  用于接收历史会话信息
            temperature: CNF.models[0].versions[0].temperature,
            topP: CNF.models[0].versions[0].top_p,
            isNetwork: 0,
            services: [],               //  当前账户可用服务列表
            service: '',
        }
    }

    changeModel = (item) => {
        this.setState({
            model: item,
            versionInfo: item.versions[0],
            temperature: item.versions[0].temperature,
            topP: item.versions[0].top_p,
            dialogueUlid: '',
            conversationId: '',
            messages: [],
        });
    }
    changeIsOpenHistory = (value) => { this.setState({ isOpenHistory: value }); }

    changeVersionInfo = (_, operations) => {
        this.setState({
            versionInfo: operations.info,
            messages: [],
            temperature: operations.info.temperature,
            topP: operations.info.top_p,
        });
    }
    changeService = (value) => {
        this.setState({ service: value });
        this.newSession();   //  新建会话，清空原内容
    }

    newSession = () => {
        this.setState({
            newSessionTag: this.state.newSessionTag === 1 ? 2 : 1,
            messages: [],
            dialogueUlid: '',
            conversationId: '',
        });
    }

    changeIsOpenNetworkSource = (value) => { this.setState({ isOpenNetworkSource: value }); }

    changeNetworkSourceData = (value) => { this.setState({ networkSourceData: value }); }


    /**
     * 获取用户策略
     */
    getPolicys = () => {
        const _this = this;
        $.ajax({
            url: `${CNF.api}policys`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    let services = [];
                    let btnArr = data.dat.btn_lists.split('|');
                    let navLists = data.dat.nav_lists
                    for (let i = 0; i < navLists.length; i++) {
                        let item = navLists[i].ptn.split('_');
                        let service = CNF.services.filter(s => s.value === item[1])[0];
                        if (service && !services.includes(service)) services.push(service);
                    }
                    services = services.sort((a, b) => {
                        return a.id - b.id;
                    })
                    _this.setState({
                        preGroup: data.dat.pre_group,
                        navLists: navLists,
                        btnLists: data.dat.btn_lists,
                        serInfos: data.dat.ser_infos,
                        qtaInfos: data.dat.qta_infos,
                        services: services,
                    });
                } else {
                    message.error(data.msg, CNF.messageDuration);
                    setTimeout(function () {
                        //  若获取策略失败，直接退出登录
                        DeleteCookies();
                    }, CNF.messageDuration * 1000);
                }
            }
        });
    }

    /**
     * 获取会话内容
     * @param {*} dialogueUlid 
     */
    getDialogueContents = (dialogueUlid, conversationId) => {
        this.setState({
            dialogueUlid: dialogueUlid,
            conversationId: conversationId,
        });
        const _this = this;
        var params = {
            dialogue_ulid: dialogueUlid,
        }
        $.ajax({
            url: `${CNF.api}dialogue/contents${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                var d = [];
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        for (let i = 0; i < data.dat.length; i++) {
                            let item = {
                                id: i + 1,
                                role: data.dat[i].role,
                                content: data.dat[i].content,
                                network_data_type: data.dat[i].network_data_type ? data.dat[i].network_data_type : '',
                                network_data_mod: data.dat[i].network_data_mod ? data.dat[i].network_data_mod : '',
                                network_data_list: data.dat[i].network_data_list ? data.dat[i].network_data_list : []
                            }
                            d.push(item);
                        }
                    }
                    _this.setState({ messages: d });
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    componentDidMount() {
        this.getPolicys();
    }

    render() {
        let p = 0;
        if (this.state.qtaInfos) {
            let _p = 100 * this.state.qtaInfos.used_tokens / this.state.qtaInfos.total_tokens;
            p = _p.toFixed(1);  //  计算百分比
        }
        if (isMobileDevice) {
            return (
                <div style={{
                    padding: '50px 15px 15px 15px',
                    backgroundColor: '#fff',
                    justifyContent: 'center',
                }}>
                    <XProvider
                        direction='ltr'
                    >
                        {/* <XinYuanMobileChat services={this.state.services} /> */}
                    </XProvider>
                </div>
            )
        } else {
            return (
                <ConfigProvider
                    locale={locale}
                    theme={{
                        token: {
                            colorPrimary: global.THEMECOLOR,
                        },
                    }}
                >
                    <div style={{
                        position: 'absolute',
                        textAlign: 'center',
                        fontSize: '11px',
                        background: 'linear-gradient(to right,#FF904D,#1677FF)',
                        width: winWidth - (this.state.collapsed ? 80 : 240),
                        height: '16px',
                        display: this.state.serInfos.length > 0 && CurrentTime() < this.state.serInfos[0].cutoff_time ? 'block' : 'none',
                        marginLeft: this.state.collapsed ? 80 : 240,
                        zIndex: 999
                    }}
                    >{this.state.serInfos.length > 0 ? this.state.serInfos[0].content : ''}</div>
                    <Flex gap="middle" wrap="wrap">
                        <Layout style={{
                            overflow: 'hidden',
                            width: '100%',
                            height: winHeight
                        }}>
                            {/* 左侧导航栏 */}
                            <Sider width='15%' style={{
                                padding: '10px',
                                color: '#000',
                                backgroundColor: '#fff',
                                borderRight: '1px solid #E8E8E8',
                            }}>
                                <Row style={{ margin: '10px' }}>
                                    <Col span={6}><LogoLT /></Col>
                                    <Col span={16}>
                                        <Button
                                            icon={<PlusOutlined />}
                                            style={{
                                                width: '100%',
                                                border: '1px solid',
                                                borderColor: global.THEMECOLOR,
                                                color: global.THEMECOLOR,
                                                height: '35px',
                                                margin: 0,
                                            }} onClick={this.newSession}>新建会话</Button>
                                    </Col>
                                </Row>
                                <Row style={{ margin: '30px 10px 20px 10px', color: '#8B8B8B' }}><Col>选择模型</Col></Row>
                                {
                                    CNF.models && CNF.models.map((item) => {
                                        return <Row
                                            className={item.value === this.state.model.value ? 'model model-selected' : 'model'}
                                            onClick={() => { this.changeModel(item) }}
                                            key={item.key}><Col>
                                                <Image height={24} style={{ borderRadius: 12, backgroundColor: '#fff' }} src={item.logo} preview={false} />
                                                <span style={{ marginLeft: 5 }}>{item.key}</span>
                                            </Col></Row>
                                    })
                                }
                                <div style={{
                                    position: 'absolute',
                                    height: 120,
                                    top: winHeight - 120,
                                    zIndex: 999,
                                    marginRight: 10,
                                }}>
                                    <div style={{
                                        background: '#F8F8FA',
                                        borderRadius: 5,
                                        padding: '5px 20px 5px 10px',
                                    }}>
                                        <span style={{ fontSize: '11px' }}>组织代码：{this.state.preGroup}</span>
                                        <Progress
                                            percent={p}
                                            size='small'
                                            style={{ margin: 0 }}
                                            strokeColor={{
                                                from: '#1677FF',
                                                to: '#FF904D',
                                            }}
                                        />
                                        <span style={{ fontSize: '11px' }}>剩余配额：{
                                            this.state.qtaInfos ? NumberToMillionFormat(this.state.qtaInfos.total_tokens - this.state.qtaInfos.used_tokens) : 0}
                                            （tokens）</span>
                                    </div>
                                    <div style={{ padding: '0 10px', marginTop: '10px' }}><XAvatar /></div>
                                </div>
                            </Sider>
                            {/* 左侧导航栏 */}
                            <Layout>
                                <Row>
                                    <Col span={this.state.isOpenHistory || this.state.isOpenNetworkSource ? (winWidth > 1440 ? 19 : 18) : 24}>
                                        {/* 头部选择框 */}
                                        <Header style={{
                                            height: 64,
                                            padding: '0 20px 0 50px',
                                            lineHeight: '64px',
                                            backgroundColor: '#F8F8FA',
                                            borderBottom: '1px solid #E8E8E8',
                                            borderRight: this.state.isOpenHistory ? '1px solid #E8E8E8' : 0,
                                        }}>
                                            <div style={{ display: 'inline-block' }}>
                                                <Image height={24} src={this.state.model.logo} style={{ borderRadius: 10, }} preview={false} />
                                                <span style={{ marginLeft: 5 }}>{this.state.model.key}</span>
                                            </div>
                                            <div style={{ display: 'inline-block', marginLeft: 8 }}>
                                                <Select
                                                    value={this.state.versionInfo.value}
                                                    style={{ width: '100%', borderColor: '#F7F9FA', height: 25 }}
                                                    popupMatchSelectWidth={false}
                                                    onChange={this.changeVersionInfo}
                                                >
                                                    {
                                                        this.state.model.versions && this.state.model.versions.map((item) => {
                                                            return <Option key={item.value} info={item} value={item.value}>{item.key}</Option>
                                                        })
                                                    }
                                                </Select>
                                            </div>
                                            <div style={{ display: 'inline-block', marginLeft: 8 }}>
                                                <span>温度</span>
                                            </div>
                                            <div style={{ display: 'inline-block', marginLeft: 5 }}>
                                                <InputNumber
                                                    style={{ width: 70, }}
                                                    size='small'
                                                    min={0.1}
                                                    max={2}
                                                    step={0.1}
                                                    value={this.state.temperature}
                                                    onChange={(value) => {
                                                        this.setState({
                                                            temperature: value,
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div style={{ display: 'inline-block', marginLeft: 8 }}>
                                                <span>P抽样</span>
                                            </div>
                                            <div style={{ display: 'inline-block', marginLeft: 5 }}>
                                                <InputNumber
                                                    style={{ width: 70, }}
                                                    size='small'
                                                    min={0}
                                                    max={1}
                                                    step={0.1}
                                                    value={this.state.topP}
                                                    onChange={(value) => {
                                                        this.setState({
                                                            topP: value,
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div style={{ display: this.state.isOpenHistory || this.state.isOpenNetworkSource ? 'none' : 'inline-block', width: 30, float: 'right' }}>
                                                <Tooltip placement='bottom' color='#fff' title={<span style={{ color: '#939394', fontSize: 12 }}>历史会话</span>}>
                                                    <Button type='link' style={{
                                                        color: '#939394',
                                                        height: 30,
                                                        width: 30,
                                                    }}
                                                        onClick={(e) => {
                                                            this.changeIsOpenHistory(true);
                                                            e.preventDefault();
                                                        }} icon={<HistoryOutlined />}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </Header>
                                        {/* 头部选择框 */}
                                        {/* 内容响应部分 */}
                                        <Content style={{
                                            color: '#fff',
                                            backgroundColor: '#F8F8FA',
                                            borderRight: this.state.isOpenHistory ? '1px solid #E8E8E8' : 0,
                                        }}>
                                            <XProvider
                                                locale={locale}
                                                bubble={{
                                                    styles: {
                                                        content: {
                                                            background: '#fff',
                                                        }
                                                    }
                                                }}
                                            >
                                                <XinYuanWebChatX
                                                    getPolicys={this.getPolicys}
                                                    preGroup={this.state.preGroup}
                                                    model={this.state.model}
                                                    versionInfo={this.state.versionInfo}
                                                    newSessionTag={this.state.newSessionTag}
                                                    isOpenHistory={this.state.isOpenHistory}
                                                    dialogueUlid={this.state.dialogueUlid}
                                                    conversationId={this.state.conversationId}
                                                    messages={this.state.messages}
                                                    temperature={this.state.temperature}
                                                    topP={this.state.topP}
                                                    services={this.state.services}
                                                    changeService={this.changeService}
                                                    isNetwork={this.state.isNetwork}
                                                    changeIsOpenNetworkSource={this.changeIsOpenNetworkSource}
                                                    changeNetworkSourceData={this.changeNetworkSourceData}
                                                />
                                            </XProvider>
                                        </Content>
                                        {/* 内容响应部分 */}

                                        {/* 内容底部部分 */}
                                        <Footer style={{
                                            height: 60,
                                            padding: '4px 50px',
                                            textAlign: 'center',
                                            color: '#8B8B8B',
                                            fontSize: '12px',
                                            backgroundColor: '#F7F9FA',
                                            borderRight: this.state.isOpenHistory ? '1px solid #E8E8E8' : 0,
                                        }}>
                                            <p style={{ margin: '3px auto' }}>所有内容均由人工智能模型输出，其内容的准确性和完整性无法保证，不代表我们的态度或观点。</p>
                                            <p style={{ margin: '5px auto' }}><span>用户协议</span> | <span>隐私政策</span></p>
                                        </Footer>
                                        {/* 内容底部部分 */}

                                    </Col>
                                    <Col span={this.state.isOpenHistory || this.state.isOpenNetworkSource ? (winWidth > 1440 ? 5 : 6) : 0}>
                                        {
                                            this.state.isOpenHistory ? (
                                                <div style={{ height: winHeight, background: '#fff' }} >
                                                    <History
                                                        service={this.state.service}
                                                        model={this.state.model}
                                                        versionInfo={this.state.versionInfo}
                                                        isOpenHistory={this.state.isOpenHistory}
                                                        changeIsOpenHistory={this.changeIsOpenHistory}
                                                        getDialogueContents={this.getDialogueContents}
                                                        dialogueUlid={this.state.dialogueUlid}
                                                        newSession={this.newSession}
                                                    />
                                                </div>
                                            ) : null
                                        }
                                        {
                                            this.state.isOpenNetworkSource ? (
                                                <NetworkSource
                                                    open={this.state.isOpenNetworkSource}
                                                    setOpen={this.changeIsOpenNetworkSource}
                                                    data={this.state.networkSourceData}
                                                />
                                            ) : null
                                        }


                                    </Col>
                                </Row>
                            </Layout>
                        </Layout>
                    </Flex>
                </ConfigProvider>
            );
        }
    }
}

export default App